// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.subscriber-analytics-container {
    padding: 24px;
    background-color: var(--theme-secondary-bg);
    min-height: 100vh;
}

.premium-card {
    background: rgba(255, 255, 255, 0.7);
    backdrop-filter: blur(10px);
    border: 1px solid rgba(255, 255, 255, 0.3);
    border-radius: 16px;
    box-shadow: 0 4px 24px -1px rgba(0, 0, 0, 0.05);
    padding: 20px;
    transition: all 0.3s ease;
}

.premium-card:hover {
    box-shadow: 0 8px 32px -1px rgba(0, 0, 0, 0.08);
    transform: translateY(-2px);
}

.stat-card {
    display: flex;
    align-items: center;
    gap: 16px;
}

.stat-icon {
    width: 60px;
    height: 60px;
    border-radius: 14px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 24px;
}

.stat-icon.total { background: linear-gradient(135deg, #6366f1 0%, #a855f7 100%); color: white; }
.stat-icon.active { background: linear-gradient(135deg, #22c55e 0%, #10b981 100%); color: white; }
.stat-icon.cancelled { background: linear-gradient(135deg, #ef4444 0%, #f97316 100%); color: white; }

.section-title {
    font-size: 1.1rem;
    font-weight: 700;
    color: var(--theme-text-color);
    margin-bottom: 20px;
    display: flex;
    align-items: center;
    gap: 8px;
}

.filter-group {
    display: flex;
    flex-wrap: wrap;
    gap: 12px;
    margin-bottom: 20px;
}

.custom-select-premium {
    padding: 8px 16px;
    border-radius: 10px;
    border: 1px solid rgba(0, 0, 0, 0.1);
    background: white;
    font-size: 14px;
    color: #4b5563;
    outline: none;
    transition: all 0.2s ease;
}

.custom-select-premium:focus {
    border-color: #6366f1;
    box-shadow: 0 0 0 2px rgba(99, 102, 241, 0.1);
}

.custom-date-premium {
    padding: 10px 14px;
    border-radius: 10px;
    border: 1px solid rgba(0, 0, 0, 0.1);
    font-size: 14px;
}

.table-premium {
    width: 100%;
    border-collapse: separate;
    border-spacing: 0 8px;
}

.table-premium thead th {
    background: transparent;
    border: none;
    color: #6b7280;
    font-weight: 600;
    font-size: 12px;
    text-transform: uppercase;
    letter-spacing: 0.05em;
    padding: 12px 16px;
}

.table-premium tbody tr {
    background: white;
    transition: transform 0.2s ease;
    box-shadow: 0 2px 4px rgba(0,0,0,0.02);
}

.table-premium tbody tr:hover {
    transform: scale(1.005);
    box-shadow: 0 4px 8px rgba(0,0,0,0.05);
}

.table-premium td {
    padding: 16px;
    border: none;
    font-size: 14px;
}

.table-premium td:first-child { border-radius: 12px 0 0 12px; }
.table-premium td:last-child { border-radius: 0 12px 12px 0; }

.status-badge {
    padding: 4px 10px;
    border-radius: 20px;
    font-size: 12px;
    font-weight: 600;
}

.status-badge.subscribed { background: #dcfce7; color: #166534; }
.status-badge.unsubscribed { background: #fee2e2; color: #991b1b; }

.chart-container {
    height: 350px;
    width: 100%;
}

.top-video-item {
    display: flex;
    align-items: center;
    gap: 12px;
    padding: 12px 0;
    border-bottom: 1px solid rgba(0,0,0,0.05);
}

.top-video-item:last-child { border-bottom: none; }

.video-rank {
    width: 32px;
    height: 32px;
    border-radius: 8px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-weight: 700;
    background: #f3f4f6;
    color: #4b5563;
}

.video-thumb {
    width: 60px;
    height: 34px;
    border-radius: 4px;
    object-fit: cover;
}

.video-info h6 { margin: 0; font-size: 14px; font-weight: 600; }
.video-info p { margin: 0; font-size: 12px; color: #9ca3af; }

.segment-pill {
    padding: 6px 12px;
    border-radius: 8px;
    background: #f3f4f6;
    font-size: 13px;
    cursor: pointer;
    transition: all 0.2s;
}

.segment-pill.active {
    background: #6366f1;
    color: white;
}

.scroll-active .react-bootstrap-table {
    overflow-x: auto;
    width: 100%;
}`, "",{"version":3,"sources":["webpack://./src/Pages/Site/Analytics/SubscriberAnalytics.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,2CAA2C;IAC3C,iBAAiB;AACrB;;AAEA;IACI,oCAAoC;IACpC,2BAA2B;IAC3B,0CAA0C;IAC1C,mBAAmB;IACnB,+CAA+C;IAC/C,aAAa;IACb,yBAAyB;AAC7B;;AAEA;IACI,+CAA+C;IAC/C,2BAA2B;AAC/B;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;AACnB;;AAEA,mBAAmB,6DAA6D,EAAE,YAAY,EAAE;AAChG,oBAAoB,6DAA6D,EAAE,YAAY,EAAE;AACjG,uBAAuB,6DAA6D,EAAE,YAAY,EAAE;;AAEpG;IACI,iBAAiB;IACjB,gBAAgB;IAChB,8BAA8B;IAC9B,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,aAAa;IACb,eAAe;IACf,SAAS;IACT,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;IACjB,mBAAmB;IACnB,oCAAoC;IACpC,iBAAiB;IACjB,eAAe;IACf,cAAc;IACd,aAAa;IACb,yBAAyB;AAC7B;;AAEA;IACI,qBAAqB;IACrB,6CAA6C;AACjD;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;IACnB,oCAAoC;IACpC,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,yBAAyB;IACzB,qBAAqB;AACzB;;AAEA;IACI,uBAAuB;IACvB,YAAY;IACZ,cAAc;IACd,gBAAgB;IAChB,eAAe;IACf,yBAAyB;IACzB,sBAAsB;IACtB,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;IACjB,+BAA+B;IAC/B,sCAAsC;AAC1C;;AAEA;IACI,uBAAuB;IACvB,sCAAsC;AAC1C;;AAEA;IACI,aAAa;IACb,YAAY;IACZ,eAAe;AACnB;;AAEA,gCAAgC,4BAA4B,EAAE;AAC9D,+BAA+B,4BAA4B,EAAE;;AAE7D;IACI,iBAAiB;IACjB,mBAAmB;IACnB,eAAe;IACf,gBAAgB;AACpB;;AAEA,2BAA2B,mBAAmB,EAAE,cAAc,EAAE;AAChE,6BAA6B,mBAAmB,EAAE,cAAc,EAAE;;AAElE;IACI,aAAa;IACb,WAAW;AACf;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,eAAe;IACf,yCAAyC;AAC7C;;AAEA,6BAA6B,mBAAmB,EAAE;;AAElD;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,gBAAgB;IAChB,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA,iBAAiB,SAAS,EAAE,eAAe,EAAE,gBAAgB,EAAE;AAC/D,gBAAgB,SAAS,EAAE,eAAe,EAAE,cAAc,EAAE;;AAE5D;IACI,iBAAiB;IACjB,kBAAkB;IAClB,mBAAmB;IACnB,eAAe;IACf,eAAe;IACf,oBAAoB;AACxB;;AAEA;IACI,mBAAmB;IACnB,YAAY;AAChB;;AAEA;IACI,gBAAgB;IAChB,WAAW;AACf","sourcesContent":[".subscriber-analytics-container {\n    padding: 24px;\n    background-color: var(--theme-secondary-bg);\n    min-height: 100vh;\n}\n\n.premium-card {\n    background: rgba(255, 255, 255, 0.7);\n    backdrop-filter: blur(10px);\n    border: 1px solid rgba(255, 255, 255, 0.3);\n    border-radius: 16px;\n    box-shadow: 0 4px 24px -1px rgba(0, 0, 0, 0.05);\n    padding: 20px;\n    transition: all 0.3s ease;\n}\n\n.premium-card:hover {\n    box-shadow: 0 8px 32px -1px rgba(0, 0, 0, 0.08);\n    transform: translateY(-2px);\n}\n\n.stat-card {\n    display: flex;\n    align-items: center;\n    gap: 16px;\n}\n\n.stat-icon {\n    width: 60px;\n    height: 60px;\n    border-radius: 14px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    font-size: 24px;\n}\n\n.stat-icon.total { background: linear-gradient(135deg, #6366f1 0%, #a855f7 100%); color: white; }\n.stat-icon.active { background: linear-gradient(135deg, #22c55e 0%, #10b981 100%); color: white; }\n.stat-icon.cancelled { background: linear-gradient(135deg, #ef4444 0%, #f97316 100%); color: white; }\n\n.section-title {\n    font-size: 1.1rem;\n    font-weight: 700;\n    color: var(--theme-text-color);\n    margin-bottom: 20px;\n    display: flex;\n    align-items: center;\n    gap: 8px;\n}\n\n.filter-group {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 12px;\n    margin-bottom: 20px;\n}\n\n.custom-select-premium {\n    padding: 8px 16px;\n    border-radius: 10px;\n    border: 1px solid rgba(0, 0, 0, 0.1);\n    background: white;\n    font-size: 14px;\n    color: #4b5563;\n    outline: none;\n    transition: all 0.2s ease;\n}\n\n.custom-select-premium:focus {\n    border-color: #6366f1;\n    box-shadow: 0 0 0 2px rgba(99, 102, 241, 0.1);\n}\n\n.custom-date-premium {\n    padding: 10px 14px;\n    border-radius: 10px;\n    border: 1px solid rgba(0, 0, 0, 0.1);\n    font-size: 14px;\n}\n\n.table-premium {\n    width: 100%;\n    border-collapse: separate;\n    border-spacing: 0 8px;\n}\n\n.table-premium thead th {\n    background: transparent;\n    border: none;\n    color: #6b7280;\n    font-weight: 600;\n    font-size: 12px;\n    text-transform: uppercase;\n    letter-spacing: 0.05em;\n    padding: 12px 16px;\n}\n\n.table-premium tbody tr {\n    background: white;\n    transition: transform 0.2s ease;\n    box-shadow: 0 2px 4px rgba(0,0,0,0.02);\n}\n\n.table-premium tbody tr:hover {\n    transform: scale(1.005);\n    box-shadow: 0 4px 8px rgba(0,0,0,0.05);\n}\n\n.table-premium td {\n    padding: 16px;\n    border: none;\n    font-size: 14px;\n}\n\n.table-premium td:first-child { border-radius: 12px 0 0 12px; }\n.table-premium td:last-child { border-radius: 0 12px 12px 0; }\n\n.status-badge {\n    padding: 4px 10px;\n    border-radius: 20px;\n    font-size: 12px;\n    font-weight: 600;\n}\n\n.status-badge.subscribed { background: #dcfce7; color: #166534; }\n.status-badge.unsubscribed { background: #fee2e2; color: #991b1b; }\n\n.chart-container {\n    height: 350px;\n    width: 100%;\n}\n\n.top-video-item {\n    display: flex;\n    align-items: center;\n    gap: 12px;\n    padding: 12px 0;\n    border-bottom: 1px solid rgba(0,0,0,0.05);\n}\n\n.top-video-item:last-child { border-bottom: none; }\n\n.video-rank {\n    width: 32px;\n    height: 32px;\n    border-radius: 8px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    font-weight: 700;\n    background: #f3f4f6;\n    color: #4b5563;\n}\n\n.video-thumb {\n    width: 60px;\n    height: 34px;\n    border-radius: 4px;\n    object-fit: cover;\n}\n\n.video-info h6 { margin: 0; font-size: 14px; font-weight: 600; }\n.video-info p { margin: 0; font-size: 12px; color: #9ca3af; }\n\n.segment-pill {\n    padding: 6px 12px;\n    border-radius: 8px;\n    background: #f3f4f6;\n    font-size: 13px;\n    cursor: pointer;\n    transition: all 0.2s;\n}\n\n.segment-pill.active {\n    background: #6366f1;\n    color: white;\n}\n\n.scroll-active .react-bootstrap-table {\n    overflow-x: auto;\n    width: 100%;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
